import { queryClient } from './queryClientService';
import { getContent } from './strapi/endpoints';

// Liste des pages principales du site pour le préchargement
export const MAIN_PAGES = [
    {
        key: 'home',
        components: [
            '[SEO][populate]=*&',
            '[Logo_section][populate]=*&',
            '[PhraseAccroche_section][populate]=*&',
            '[YoutubeVideo_section][populate]=*&',
            '[AtelierMisEnAvant_section][populate]=*&',
            '[ProchainesRencontres_section][populate][Cartes_Rencontre][populate]=Photo&',
            '[ProchainesRencontres_section][populate][Cartes_Rencontre][populate]=Bouton&',
            '[Ebook_section][populate]=*&',
            '[Newsletter_section][populate]=*&',
            '[Avis_section][populate]=*',
        ]
    },
    {
        key: 'about',
        components: [
            '[SEO][populate]=*&',
            '[TitrePage_section][populate]=*&',
            '[Intro_section][populate]=*&',
            '[Part1_section][populate]=*&',
            '[Part2_section][populate]=*&',
            '[Part3_section][populate]=*&',
            '[Part4_section][populate]=*&',
            '[Workshops_section][populate][Cartes_Atelier][populate]=*',
        ]
    },
    /* {
        key: 'support',
        components: [
            '[SEO][populate]=*&',
            '[TitrePage_section][populate]=*&',
            '[Intro_section][populate]=*&',
            '[Part1_section][populate]=*&',
            '[Part2_section][populate]=*&',
            '[Part3_section][populate]=*&',
            '[Part4_section][populate]=*&',
            '[Part5Steps_section][populate]=*&',
            '[Part6_section][populate][Cataclysme][populate]=Photo&',
            '[Part6_section][populate][Épuisée][populate]=*&',
            '[Part6_section][populate][Culpabilité][populate]=Photo&',
            '[Part6_section][populate][Jusqu_au_jour][populate]=*&',
            '[Part7_section][populate][Photos][populate]=*&',
            '[Part7_section][populate][Étapes][populate]=*&',
            '[Part8_section][populate][Accompagnement][populate]=*&',
            '[Part8_section][populate][Bouton][populate]=*&',
            '[Part9_section][populate][Outils][populate]=*',
        ]
    },
    {
        key: 'astro',
        components: [
            '[SEO][populate]=*&',
            '[TitrePage_section][populate]=*&',
            '[Intro_section][populate]=*&',
            '[Part1_section][populate]=*&',
            '[Part2_section][populate]=*&',
            '[Part3_section][populate]=*&',
            '[Astro_cards_section][populate][Cartes_Astro][populate]=*&',
            '[Astro_packs_section][populate][Packs_Astro][populate]=*',
        ]
    }, */
    {
        key: 'workshops',
        components: [
            '[SEO][populate]=*&',
            '[TitrePage_section][populate]=*&',
            '[Cartes_Atelier][populate]=*',
        ],
    },
    {
        key: 'ebook',
        components: [
            '[SEO][populate]=*&',
            '[Ebook][populate]=*&',
            '[EnTete][populate]=*&',
            '[ObjectifsPart][populate][Objectifs][populate]=*&',
            '[Moi][populate]=*&',
            '[Remerciements][populate]=*',
        ],
    },
    {
        key: 'newsletter-subscription',
        components: [
            '[SEO][populate]=*&',
            '[EnTete][populate]=*&',
            '[Remerciements][populate]=*',
        ],
    },
    {
        key: 'blog',
        components: [
            '[SEO][populate]=*&',
            '[TitrePage_section][populate]=*&',
            '[Configuration][populate]=*',
        ],
    },
    {
        key: 'redirections',
        components: [
            '[SEO][populate]=*&',
            '[Photo][populate]=*&',
            '[Bouton][populate]=*'
        ],
    },
    {
        key: 'e404',
        components: [
            '=*',
        ],
    },

];

// Vérifier la fraîcheur des données et mettre à jour si nécessaire
export const checkDataFreshness = async (key, fetchParams) => {
    try {
        // Vérifie si les données sont dans le cache
        const cachedData = queryClient.getQueryData(key);

        if (!cachedData) return false;

        // Vérifier si les données sont périmées
        const queryState = queryClient.getQueryState(key);
        if (!queryState || queryState.isStale) {
            // Si les données sont périmées, on les actualise en arrière-plan
            // Utiliser prefetchQuery pour éviter de déclencher des rendus inutiles
            await queryClient.prefetchQuery({
                queryKey: key,
                queryFn: async () => {
                    const response = await fetchParams();
                    return response.data.data;
                },
                staleTime: 5 * 60 * 1000, // 5 minutes
            });
            return true; // Des données ont été récupérées et mises à jour
        }

        return true; // Des données fraîches étaient déjà en cache
    } catch (error) {
        console.error("Erreur lors de la vérification de fraîcheur des données:", error);
        return false;
    }
};

// Fonction pour découvrir et précharger les collections
export const discoverAndCacheCollections = async () => {
    try {
        console.debug('Début de la découverte et du préchargement des collections...');
        
        // On vérifie d'abord si workshops est déjà en cache
        const workshopsKey = ['strapi-content', 'workshops'];
        let workshopsData = queryClient.getQueryData(workshopsKey);
        
        // Si non, on le charge
        if (!workshopsData) {
            console.debug('Page workshops non trouvée dans le cache, chargement en cours...');
            try {
                const response = await getContent({
                    page: 'workshops',
                    components: [
                        '[SEO][populate]=*&',
                        '[TitrePage_section][populate]=*&',
                        '[Cartes_Atelier][populate]=*',
                    ]
                });
                
                if (response && response.data && response.data.data) {
                    workshopsData = response.data.data;
                    console.debug('Données workshops chargées avec succès');
                    
                    // Stockage dans le cache
                    queryClient.setQueryData(workshopsKey, workshopsData);
                } else {
                    console.error('Réponse invalide lors du chargement des workshops:', response);
                    return;
                }
            } catch (error) {
                console.error('Erreur lors du chargement des workshops:', error);
                return;
            }
        } else {
            console.debug('Données workshops trouvées dans le cache');
        }
        
        // Vérifier que workshopsData est un tableau ou qu'il contient des données utilisables
        if (!workshopsData) {
            console.error('Structure des données workshops invalide:', workshopsData);
            return;
        }
        
        // Si workshopsData est un tableau, utiliser directement les entrées
        // Sinon, vérifier s'il s'agit d'un objet avec des propriétés pertinentes
        const atelierItems = Array.isArray(workshopsData) 
            ? workshopsData 
            : (workshopsData.Cartes_Atelier || []);
        
        // Log détaillé pour le débogage
        console.debug(`Nombre d'éléments trouvés: ${atelierItems.length}`);
        
        // Examiner chaque élément pour le débogage
        for (let i = 0; i < atelierItems.length; i++) {
            const item = atelierItems[i];
            console.debug(`Élément #${i+1}:`, 
                         `ID: ${item.id || 'non défini'}`, 
                         `Slug: ${item.Slug || 'non défini'}`);
        }
        
        // Maintenant que nous avons les données, parcourons les éléments pour trouver les slugs
        const slugPromises = [];
        
        for (const item of atelierItems) {
            // Vérifier que le slug est à la racine de l'objet
            if (item.Slug) {
                const slug = item.Slug;
                
                // Vérifier que le slug est bien formaté
                if (typeof slug !== 'string' || slug.trim() === '') {
                    console.debug(`Slug invalide pour l'élément ${item.id}:`, slug);
                    continue;
                }
                
                console.debug(`Traitement du slug: ${slug}`);
                
                const collectionKey = ['strapi-collection', 'workshops', slug];
                
                // Vérifier si cette collection est déjà en cache
                const isCached = queryClient.getQueryData(collectionKey);
                
                if (!isCached) {
                    console.debug(`Préchargement de la collection: workshops/${slug}`);
                    
                    // Créer une promesse pour chaque requête
                    const slugPromise = (async () => {
                        try {
                            const components = [
                                '[SEO][populate]=*&',
                                '[TitrePage_section][populate]=*&',
                                '[Cartes_Atelier][populate]=*',
                            ];
                            
                            const response = await getContent(
                                { collections: 'workshops', slug, components }, 
                                true, 
                                false
                            );
                            
                            if (response && response.data && response.data.data) {
                                // Stockage explicite dans le cache
                                queryClient.setQueryData(collectionKey, response.data.data);
                                console.debug(`Collection workshops/${slug} mise en cache avec succès`);
                                
                                // Vérifier que les données sont bien dans le cache
                                const verif = queryClient.getQueryData(collectionKey);
                                console.debug(`Vérification du cache pour ${slug}:`, verif ? 'OK' : 'Échec');
                            } else {
                                console.error(`Réponse invalide pour ${slug}:`, response);
                            }
                        } catch (error) {
                            console.error(`Erreur lors du préchargement de workshops/${slug}:`, error);
                        }
                    })();
                    
                    slugPromises.push(slugPromise);
                } else {
                    console.debug(`Collection workshops/${slug} déjà en cache`);
                }
            } else {
                console.debug(`Élément sans slug:`, item.id);
            }
        }
        
        // Attendre que toutes les requêtes soient terminées avec un délai entre chaque
        if (slugPromises.length > 0) {
            console.debug(`Exécution de ${slugPromises.length} requêtes de préchargement...`);
            
            // Utiliser une boucle avec un délai au lieu de Promise.all
            for (let i = 0; i < slugPromises.length; i++) {
                await slugPromises[i];
                
                // Pause entre chaque requête pour éviter de surcharger l'API
                if (i < slugPromises.length - 1) {
                    await new Promise(resolve => setTimeout(resolve, 300));
                }
            }
            
            console.debug('Toutes les collections ont été préchargées');
        } else {
            console.debug('Aucune collection à précharger');
        }
    } catch (error) {
        console.error("Erreur lors de la découverte et du préchargement des collections:", error);
    }
};

// Préchargement des pages principales - Avec vérification pour éviter la récursivité
let isPreloading = false;
export const preloadMainPages = async () => {
    // Éviter des appels multiples simultanés
    if (isPreloading) return;
    isPreloading = true;

    // Exécute le préchargement avec un petit délai
    setTimeout(async () => {
        try {
            console.debug("Démarrage du préchargement des pages principales");
            for (const page of MAIN_PAGES) {
                const key = ['strapi-content', page.key];

                // Vérifie si les données sont déjà en cache
                const isCached = queryClient.getQueryData(key);

                // Si pas en cache, précharge les données
                if (!isCached) {
                    console.debug(`Préchargement de la page: ${page.key}`);
                    await queryClient.prefetchQuery({
                        queryKey: key,
                        queryFn: async () => {
                            const response = await getContent({
                                page: page.key,
                                components: page.components
                            });
                            return response.data.data;
                        },
                        staleTime: 5 * 60 * 1000 // 5 minutes
                    });

                    // Petite pause entre chaque requête
                    await new Promise(resolve => setTimeout(resolve, 300));
                }
            }
            await discoverAndCacheCollections();
            console.debug("Préchargement complet (pages principales + collections dynamiques)");
            console.debug("Préchargement des pages principales terminé");
        } catch (error) {
            console.error("Erreur lors du préchargement des pages:", error);
        } finally {
            isPreloading = false; // Important: remettre à false quoi qu'il arrive
        }
    }, 2000); // Délai plus long pour être sûr que le rendu initial est terminé
};

// Flag global pour l'actualisation périodique
let isRefreshing = false;
// Actualiser périodiquement le cache avec focus sur MAIN_PAGES
export const startPeriodicCacheRefresh = (intervalMinutes = 30) => {
    const intervalMs = intervalMinutes * 60 * 1000;

    const refreshCache = async () => {
        // Éviter des actualisations simultanées
        if (isRefreshing) return;
        isRefreshing = true;

        try {
            console.debug("Actualisation périodique du cache...");
            
            // 1. Collecter toutes les clés de requête Strapi actuellement en cache
            const allStrapiQueries = queryClient.getQueryCache().findAll(
                query => query.queryKey[0]?.includes('strapi')
            );
            
            // Afficher les clés pour le débogage
            console.debug("Clés Strapi en cache:", allStrapiQueries.map(q => q.queryKey));
            
            // 2. S'assurer que toutes les pages principales sont en cache ou les recharger
            for (const page of MAIN_PAGES) {
                const key = ['strapi-content', page.key];
                
                // Vérifier si cette page est déjà en cache
                const existingQuery = queryClient.getQueryState(key);
                const isInCache = existingQuery && existingQuery.data;
                
                if (!isInCache) {
                    // Si la page n'est pas en cache, la précharger
                    console.debug(`Préchargement de la page principale: ${page.key}`);
                    try {
                        // Utiliser fetchQuery qui garde les données même si elles ne sont pas utilisées
                        await queryClient.fetchQuery({
                            queryKey: key,
                            queryFn: async () => {
                                const response = await getContent({
                                    page: page.key,
                                    components: page.components
                                });
                                return response.data.data;
                            },
                            staleTime: 5 * 60 * 1000, // 5 minutes
                            cacheTime: 60 * 60 * 1000, // 60 minutes - Prolonger pour éviter le nettoyage
                        });
                    } catch (error) {
                        console.error(`Erreur lors du préchargement de ${page.key}:`, error);
                    }
                } else {
                    // Si la page est déjà en cache, étendre sa durée de vie
                    console.debug(`Extension de la durée de vie du cache pour: ${page.key}`);
                    try {
                        // Toucher la requête pour réinitialiser son compteur de garbage collection
                        queryClient.setQueryData(key, existingQuery.data);
                    } catch (error) {
                        console.error(`Erreur lors de l'extension du cache pour ${page.key}:`, error);
                    }
                }
                
                // Petite pause entre les requêtes
                await new Promise(resolve => setTimeout(resolve, 300));
            }

            // 3. Pour les autres requêtes Strapi, également étendre leur durée de vie
            for (const query of allStrapiQueries) {
                // Ignorer les pages principales car elles ont déjà été traitées
                const isMainPage = MAIN_PAGES.some(page => 
                    JSON.stringify(query.queryKey) === JSON.stringify(['strapi-content', page.key])
                );
                
                if (!isMainPage) {
                    try {
                        // Toucher également cette requête pour réinitialiser sa durée de vie
                        const state = queryClient.getQueryState(query.queryKey);
                        if (state && state.data) {
                            queryClient.setQueryData(query.queryKey, state.data);
                            console.debug(`Extension de la durée de vie du cache pour: ${JSON.stringify(query.queryKey)}`);
                        }
                    } catch (error) {
                        console.error(`Erreur lors de l'extension du cache pour ${JSON.stringify(query.queryKey)}:`, error);
                    }
                }
            }

            // Avant la fin de la fonction refreshCache
            await discoverAndCacheCollections();
            console.debug("Actualisation périodique complète (pages + collections)");

            console.debug("Actualisation périodique du cache terminée");
        } catch (error) {
            console.error("Erreur lors de l'actualisation périodique:", error);
        } finally {
            isRefreshing = false; // Important: remettre à false quoi qu'il arrive
        }
    };

    // Démarrer avec un délai initial
    const initialDelay = setTimeout(() => {
        refreshCache();
        // Démarrer l'intervalle récurrent
        const intervalId = setInterval(refreshCache, intervalMs);
        initialDelayRef.current = null;
        intervalIdRef.current = intervalId;
    }, 3 * 60 * 1000); // Premier refresh après 3 minutes (réduit de 5 à 3 min)

    // Références pour le nettoyage
    const initialDelayRef = { current: initialDelay };
    const intervalIdRef = { current: null };

    // Retourner une fonction pour arrêter l'intervalle si nécessaire
    return () => {
        if (initialDelayRef.current) {
            clearTimeout(initialDelayRef.current);
        }
        if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
        }
    };
};

// Vérifier si une page a été modifiée sur Strapi en comparant updatedAt
export const checkPageUpdates = async (pageKey, components) => {
    try {
        // Récupérer la version actuelle depuis Strapi
        const response = await getContent({
            page: pageKey,
            components: components
        });
        const latestData = response.data.data;

        // Récupérer la version en cache
        const cachedData = queryClient.getQueryData(['strapi-content', pageKey]);

        // Si pas de cache, considérer comme mise à jour nécessaire
        if (!cachedData) return true;

        // Comparer uniquement les timestamps updatedAt
        if (latestData.updatedAt && cachedData.updatedAt) {
            return new Date(latestData.updatedAt) > new Date(cachedData.updatedAt);
        }

        // Si updatedAt n'est pas disponible, retourner false pour éviter des mises à jour inutiles
        return false;
    } catch (error) {
        console.error(`Erreur lors de la vérification des mises à jour pour ${pageKey}:`, error);
        return false;
    }
};

// Fonction d'actualisation manuelle que vous pouvez appeler quand nécessaire à associé à un bouton par exemple (non utilisé sur ce site)
export const refreshAllPages = async () => {
    for (const page of MAIN_PAGES) {
        const key = ['strapi-content', page.key];
        await queryClient.invalidateQueries({ queryKey: key, exact: true });
        await queryClient.refetchQueries({ 
            queryKey: key, 
            exact: true,
            stale: true
        });
        // Petite pause entre chaque requête
        await new Promise(resolve => setTimeout(resolve, 300));
    }
    console.debug("Toutes les pages principales ont été actualisées");
};